import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { IAuthState, AuthStore } from './auth.store';

@Injectable({ providedIn: 'root' })
export class AuthQuery extends Query<IAuthState> {
  public readonly userInfo$ = this.select((state) => state.userInfo);
  public readonly isLoggedIn$ = this.select((state) => !!state.userInfo);
  public readonly profile$ = this.select((state) => state.profile);

  public constructor(protected store: AuthStore) {
    super(store);
  }
}
